import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  TablePagination,
  Typography,
} from "@material-ui/core";
import { getProfilePosition } from "../../actions/position-actions";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import IconButton from "../../utils/form/IconButton";
import Search from "../../images/icons/search.svg";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import DetailedTable from "./tableCharges";
import { get} from "../../actions/generic-actions";
import { useStateValue } from "../../context/store";
import ChargesSearch from "./chargesSearch";
import ChargesForm from "./chargesForm";
import { headers } from "./data";
import {permissionsConstans} from '../../constansPermissions'
import _ from "lodash";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  button: {
    color: "blue",
    background: "#e7f103",
    "&:hover": { color: "white", background: "#0f70b7" },
  },
  titleCreate: {
    fontFamily: "Roboto",
    fontSize: 17,
    fontStyle: "normal",
    fontWeight: 500,
    letterSpacing: "0em",
    textAlign: "left",
  },
});

const Charges = (props) => {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [showCreate, setShowCreate] = useState(false);
  const [stateEdit, setStateEdit] = useState(false);
  const [resetTable, setResetTable] = useState(false);
  const [charges, setCharges] = useState([]);
  const [chargesActive, setChargesActive] = useState([]);
  const [{}, dispatch] = useStateValue();
  const [data, setData] = useState([]);
  const [filterCharges, setFilterCharges] = useState([]);
  const getCharges = async () => {
    const response = await get("/charge/");
    setFilterCharges(response.data.chargeList);
    setCharges([...response.data.chargeList]);
    setData([...response.data.chargeList]);
  };
  useEffect(() => {
    getCharges();
    const getListaRegionalStatus = async () => {
      const response = await getProfilePosition("ACTIVO");
      setChargesActive(
        _.sortBy(response?.data?.chargeList, [
          function (o) {
            return o.denomination;
          },
        ])
      );
    };
    getListaRegionalStatus();

    setPage(0);
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Cargos   |   Cargos  ",
      breadCrumbSubText: "Cargos",
      index: 5,
    });
  }, [!stateEdit]);

  useEffect(() => {
    setPage(0);
  }, [!resetTable]);

  const rows = data;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const dataFilter = (x) => setData(x);
  const refresPaginator = () => setResetTable(!resetTable);
  const refreshCharge = () => {
    getCharges();
    setStateEdit(!stateEdit);
  };

  const toggleCreateBtn = () => {
    setShowCreate(!showCreate);
  };

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'CAR')
 
    if(module?.functionalities?.some((x)=> x === permissionsConstans.CAR_CREAR)){
     return <React.Fragment>
              <Typography className={classes.titleCreate}>
                Registro cargos nuevos
              </Typography>
              <ChargesForm
                closeCreate={toggleCreateBtn}
                charges={chargesActive}
                resetData={refreshCharge}
              />
           </React.Fragment>
   } if (module?.functionalities?.some((x)=> x === permissionsConstans.CAR_CREAR)){
     return  <ChargesSearch
              dataFilter={dataFilter}
              stateEdit={() => refreshCharge}
              refresPaginator={refresPaginator}
              currentData={[...charges]}
            />
   }

   }

   const validationPermissionSearch = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'CAR')
 
    if (module?.functionalities?.some((x)=> x === permissionsConstans.CAR_CREAR)){
     return  <ChargesSearch
              dataFilter={dataFilter}
              stateEdit={() => refreshCharge}
              refresPaginator={refresPaginator}
              currentData={[...charges]}
            />
   }

   } 

  return (
    <div style={{ marginTop: "40px" }}>
    {validationPermission()}
     {validationPermissionSearch()}
     

      <Typography className={classes.titleCreate}>
        Información cargos
      </Typography>
      {(rowsPerPage > 0
        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : rows
      ).map((row, index) => (
        <DetailedTable
          refreshCharge={refreshCharge}
          headers={headers}
          data={row}
          chargesActive={chargesActive}
          // onView={verRequisicion}
          // onDelete={anularRequisicionConfirm}
        />
      ))}
      {rows.length > 0 ? (
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          style={{ display: "flex", justifyContent: "center" }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage='Registros por página'
          count={rows.length}
          page={page}
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Charges);
